module.exports = __webpack_public_path__ + "media/images/gallery/constellations/en_layer_off-971f11ddaef7e6a975008d9722a33bf6.jpg";